export default {
  setEducationListState(state, data) {
    state.educationList = data.length ? data : [state.educationItem];
    state.educationErrorList = state.educationList.map(() => state.educationErrorItem);
  },
  addEmptyEducationItem(state) {
    state.educationList = [state.educationItem, ...state.educationList];
    state.educationErrorList = [state.educationErrorItem, ...state.educationErrorList];
  },
  mutateEducationByIndexState(state, data) {
    let list = [...state.educationList];
    list[data.index] = {...list[data.index], ...data.changedField};
    state.educationList = list;
  },
  deleteEducationItem(state, index) {
    state.educationList.splice(index, 1);
    state.educationErrorList.splice(index, 1);
  },
  mutateEducationErrorItem(state, data) {
    let list = [...state.educationErrorList];
    list[data.index] = {...list[data.index], ...data.changedField};
    state.educationErrorList = list;
  }
};
